<footer>
    <div class="container">
        <div class="row">
            <div class="col-12 col-md-5 col-lg-3 col-xl-3">
                <img class="mb-3 footer-logo" src="assets/images/logo-white.svg" alt="Arcon" />
                <p class="text-justify">Setting benchmarks in project logistics, chemical transportation, container
                    trading, custom broking, and IT solutions.</p>
                <ul class="d-flex ps-0 mt-3 mt-md-2 mt-lg-4 mb-4 mb-md-3 mb-lg-0 style-none social-link">
                    <li>
                        <a href="https://www.facebook.com/arconcontainer/" target="_blank">
                            <svg class="facebook"
                                id="Icon_ICON_feather_facebook_SIZE_MEDIUM_STATE_DEFAULT_STYLE_STYLE3_"
                                data-name="Icon [ICON=feather/facebook][SIZE=MEDIUM][STATE=DEFAULT][STYLE=STYLE3]"
                                xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
                                <rect width="20" height="20" opacity="0" />
                                <g id="Icon" transform="translate(5.833 1.667)">
                                    <path id="a526835c-504d-4946-bde1-0a4e103045e0"
                                        d="M18,2H15a5,5,0,0,0-5,5v3H7v4h3v8h4V14h3l1-4H14V7a1,1,0,0,1,1-1h3Z"
                                        transform="translate(-8.333 -3.667)" />
                                </g>
                            </svg>
                        </a>
                    </li>
                    <li>
                        <a class="twitter-a" href="https://twitter.com/arconcontainer?s=21&t=ZHYLAXdi7IYmmqc4V1heWg/"
                            target="_blank">
                            <svg class="twitter" xmlns="http://www.w3.org/2000/svg" width="20" height="16.313"
                                viewBox="0 0 20 16.313">
                                <g id="Icon">
                                    <path id="_58e66d10-56e1-480f-9d8d-3aff2dc3a743"
                                        data-name="58e66d10-56e1-480f-9d8d-3aff2dc3a743"
                                        d="M20.909,2.727a9.9,9.9,0,0,1-2.854,1.391,4.073,4.073,0,0,0-7.146,2.727v.91A9.691,9.691,0,0,1,2.727,3.636S-.909,11.818,7.273,15.455A10.59,10.59,0,0,1,.909,17.273c8.182,4.545,18.182,0,18.182-10.455a4.056,4.056,0,0,0-.073-.754A7.017,7.017,0,0,0,20.909,2.727Z"
                                        transform="translate(-0.909 -2.718)" />
                                </g>
                            </svg>
                        </a>
                    </li>
                    <li>
                        <a href="https://www.linkedin.com/company/arconcontainers/" target="_blank">
                            <svg class="linkedin" xmlns="http://www.w3.org/2000/svg" width="20" height="19"
                                viewBox="0 0 20 19">
                                <g id="Icon" transform="translate(0.001 0)">
                                    <path id="_1009d21e-9af9-4bfc-ae51-b1a15a67e150"
                                        data-name="1009d21e-9af9-4bfc-ae51-b1a15a67e150"
                                        d="M16,8a6,6,0,0,1,6,6v7H18V14a2,2,0,0,0-4,0v7H10V14A6,6,0,0,1,16,8Z"
                                        transform="translate(-2 -2)" />
                                    <rect id="_7890c612-7bc5-4329-9c65-e092b1c7cbee"
                                        data-name="7890c612-7bc5-4329-9c65-e092b1c7cbee" width="4" height="12"
                                        transform="translate(-0.001 7)" />
                                    <circle id="_770bbded-1797-4e05-8a3e-cd0b60bfd42c"
                                        data-name="770bbded-1797-4e05-8a3e-cd0b60bfd42c" cx="2" cy="2" r="2"
                                        transform="translate(-0.001 0)" />
                                </g>
                            </svg>
                        </a>
                    </li>
                    <li>
                        <a href="https://instagram.com/arconcontainer?igshid=YmMyMTA2M2Y=" target="_blank">
                            <svg class="instagram" width="20px" height="20px" viewBox="0 0 20 20" version="1.1"
                                xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                <g id="Page-1" stroke="none" stroke-width="1" fill-rule="evenodd">
                                    <g id="Dribbble-Light-Preview" transform="translate(-340.000000, -7439.000000)">
                                        <g id="icons" transform="translate(56.000000, 160.000000)">
                                            <path
                                                d="M289.869652,7279.12273 C288.241769,7279.19618 286.830805,7279.5942 285.691486,7280.72871 C284.548187,7281.86918 284.155147,7283.28558 284.081514,7284.89653 C284.035742,7285.90201 283.768077,7293.49818 284.544207,7295.49028 C285.067597,7296.83422 286.098457,7297.86749 287.454694,7298.39256 C288.087538,7298.63872 288.809936,7298.80547 289.869652,7298.85411 C298.730467,7299.25511 302.015089,7299.03674 303.400182,7295.49028 C303.645956,7294.859 303.815113,7294.1374 303.86188,7293.08031 C304.26686,7284.19677 303.796207,7282.27117 302.251908,7280.72871 C301.027016,7279.50685 299.5862,7278.67508 289.869652,7279.12273 M289.951245,7297.06748 C288.981083,7297.0238 288.454707,7296.86201 288.103459,7296.72603 C287.219865,7296.3826 286.556174,7295.72155 286.214876,7294.84312 C285.623823,7293.32944 285.819846,7286.14023 285.872583,7284.97693 C285.924325,7283.83745 286.155174,7282.79624 286.959165,7281.99226 C287.954203,7280.99968 289.239792,7280.51332 297.993144,7280.90837 C299.135448,7280.95998 300.179243,7281.19026 300.985224,7281.99226 C301.980262,7282.98483 302.473801,7284.28014 302.071806,7292.99991 C302.028024,7293.96767 301.865833,7294.49274 301.729513,7294.84312 C300.829003,7297.15085 298.757333,7297.47145 289.951245,7297.06748 M298.089663,7283.68956 C298.089663,7284.34665 298.623998,7284.88065 299.283709,7284.88065 C299.943419,7284.88065 300.47875,7284.34665 300.47875,7283.68956 C300.47875,7283.03248 299.943419,7282.49847 299.283709,7282.49847 C298.623998,7282.49847 298.089663,7283.03248 298.089663,7283.68956 M288.862673,7288.98792 C288.862673,7291.80286 291.150266,7294.08479 293.972194,7294.08479 C296.794123,7294.08479 299.081716,7291.80286 299.081716,7288.98792 C299.081716,7286.17298 296.794123,7283.89205 293.972194,7283.89205 C291.150266,7283.89205 288.862673,7286.17298 288.862673,7288.98792 M290.655732,7288.98792 C290.655732,7287.16159 292.140329,7285.67967 293.972194,7285.67967 C295.80406,7285.67967 297.288657,7287.16159 297.288657,7288.98792 C297.288657,7290.81525 295.80406,7292.29716 293.972194,7292.29716 C292.140329,7292.29716 290.655732,7290.81525 290.655732,7288.98792"
                                                id="instagram-[#167]"></path>
                                        </g>
                                    </g>
                                </g>
                            </svg>
                        </a>
                    </li>
                </ul>
            </div>
            <div class="col-12 col-md-7 col-lg-9 col-xl-8 offset-xl-1">
                <div class="row footer-row">
                    <div class="col-12 col-md-6 col-lg-4 set-nav-link">
                        <ul class="style-none">
                            <li class="head-li">
                                <p>
                                    <!-- (click)="routePage('product-and-services'); scrollInElementByComponent('product-and-services', 'productServicesBanner')" -->
                                    <a class="nav-link-r">Products & Services</a>
                                </p>
                            </li>
                            <li>
                                <p>
                                    <!-- (click)="routePage('product-and-services'); scrollInElementByComponent('product-and-services', 'productOneWay')" -->
                                    <a class="nav-link">One-Way Container Movement</a>
                                </p>
                            </li>
                            <li>
                                <p>
                                    <!-- (click)="routePage('product-and-services'); scrollInElementByComponent('product-and-services', 'productBuySell')" -->
                                    <a class="nav-link">Click To Trade</a>
                                </p>
                            </li>
                            <li>
                                <p>
                                    <!-- (click)="routePage('product-and-services'); scrollInElementByComponent('product-and-services', 'productLeaseWithEase')" -->
                                    <a class="nav-link">Lease With Ease</a>
                                </p>
                            </li>
                            <li>
                                <p>
                                    <!-- (click)="routePage('product-and-services'); scrollInElementByComponent('product-and-services', 'ourContainer')" -->
                                    <a class="nav-link">ARCON's Container</a>
                                </p>
                            </li>
                        </ul>
                    </div>
                    <div class="col-12 col-md-6 col-lg-4">
                        <ul class="style-none">
                            <li class="head-li">
                                <p>
                                    <!-- (click)="routePage('resources', resourceData?.[0]?.slug)" -->
                                    <a class="nav-link-r">Resources</a>
                                </p>
                            </li>
                            <li *ngFor="let data of resourceData">
                                <p>
                                    <!-- (click)="routePage('resources', data.slug); scrollInElementByComponent('resources', 'resources-view')" -->
                                    <a class="nav-link">{{data.name}}</a>
                                </p>
                            </li>
                            <!-- <li>
                  <p>
                    <a class="nav-link" (click)="routePage('resources');">Case Studies</a>
                  </p>
                </li>
                <li>
                  <p>
                    <a class="nav-link" (click)="routePage('resources');">Articles</a>
                  </p>
                </li> -->
                        </ul>
                    </div>
                    <div class="col-12 col-md-6 col-lg-4">
                        <ul class="style-none">
                            <li class="head-li">
                                <p>
                                    <!-- (click)="routePage('about-us'); scrollInElementByComponent('about-us', 'visionAndMission')" -->
                                    <a class="nav-link-r">Company</a>
                                </p>
                            </li>
                            <li>
                                <p>
                                    <!-- (click)="routePage('about-us'); scrollInElementByComponent('about-us', 'managementTeam')" -->
                                    <a class="nav-link">Management Team</a>
                                </p>
                            </li>
                            <li>
                                <p>
                                    <!-- (click)="routePage('about-us'); scrollInElementByComponent('about-us', 'lifeAtArcon')" -->
                                    <a class="nav-link">Life At ARCON</a>
                                </p>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="copyright mt-4 mt-lg-5">
        <div class="container">
            <div class="d-md-flex justify-content-between align-items-center">
                <p class="rights">© 2022 ARCON. All Rights Reserved.</p>
                <ul class="d-flex mb-0 privacy-policy ">
                    <li>
                        <p class="rights">
                            <!-- (click)="routePage('privacy-policy');" -->
                            <a>Privacy Policy </a>
                        </p>
                    </li>
                    <li class="ms-5">
                        <p class="rights">
                            <!-- (click)="routePage('terms-of-service');" -->
                            <a>Terms of service </a>
                        </p>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</footer>